import PropTypes from 'prop-types';
import React from 'react';
import * as Ui from './PreviewViewSwitcher.styles';

const PreviewViewSwitcher = ({
  activeView,
  ariaLabel,
  floating = false,
  onChange,
  primaryLabel,
  primaryView,
  previewLabel,
}) => (
  <Ui.Switcher $floating={floating} role="toolbar" aria-label={ariaLabel}>
    <Ui.Switch
      type="button"
      $selected={activeView === primaryView}
      aria-pressed={activeView === primaryView}
      onClick={() => onChange(primaryView)}
    >
      {primaryLabel}
    </Ui.Switch>
    <Ui.Switch
      type="button"
      $selected={activeView === 'preview'}
      aria-pressed={activeView === 'preview'}
      onClick={() => onChange('preview')}
    >
      {previewLabel}
    </Ui.Switch>
  </Ui.Switcher>
);

PreviewViewSwitcher.propTypes = {
  activeView: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  floating: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  primaryLabel: PropTypes.string.isRequired,
  primaryView: PropTypes.string.isRequired,
  previewLabel: PropTypes.string.isRequired,
};

export default PreviewViewSwitcher;
